module.exports = __webpack_public_path__ + "img/simulateur_credit_conso-lazy.ace5ee7a.jpg";